import React from 'react';
// import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
// import PublishIcon from '@mui/icons-material/Publish';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
// import GetAppIcon from '@mui/icons-material/GetApp';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import InfoOutlined from '@mui/icons-material/InfoOutlined';
// import Printicon from '@mui/icons-material/Print';
import MenuItem from '@mui/material/MenuItem';
import {
// Box,
// Tab,
} from '@mui/material';
import {
// TabContext,
// TabList,
// TabPanel,
} from '@mui/lab';

import {
  FlexGridColumnGroup,
  // FlexGridCellTemplate
} from '@grapecity/wijmo.react.grid';

import {
// createTyohyoPdf,
// getCodeFromGeneralPurposeMap,
// changeDateFormat,
// getErrorCode,
// API_CODE,
// getErrorMessages,
// getResponseResult,
// getDataFromGeneralPurposeMap,
// getMaxDeleteNum
} from '../../../../common/common.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
import MainContainer from '../../../organisms/MainContainer.js';
import {renderSelect} from '../../../atoms/CustomPart.js';
// import {createSearchList} from '../../../../../common/ComboParts.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
// import MuiTooltip from '../../../../atoms/MuiTooltip.js';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
// import KyogaCompanyInfo from '../../../../molecules/KyogaCompanyInformation.js';
// import * as validateRule from '../../../validateRule.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
// import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';
// import {setSessionObject} from '../../../../common/Session.js';
import Typography from '@mui/material/Typography';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import CustomAccordion from '../../../molecules/Accordion.js';
import {CellType} from '@grapecity/wijmo.grid';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.TSTK_IMPLEMENT_STATUS_LIST.name, href: ''},
];

const styles = (theme) => ({

});

// 一覧
const TsViews = [
  {binding: 'tsTkGubun', header: ' ', dataType: 'String', width: 280, readOnly: true},
  {binding: 'tsTkCoNw', header: '中国電力ネットワーク株式会社', dataType: 'String', width: 120, readOnly: true, align: 'right'},
  {binding: 'tsTkCoHa', header: '一般財団法人中国電気保安協会', dataType: 'String', width: 120, readOnly: true, align: 'right'},
  {binding: 'tsTkCoHbTt', header: '鳥取県電気工事業工業組合', dataType: 'String', width: 120, readOnly: true, align: 'right'},
  {binding: 'tsTkCoHbSm', header: '島根県電気工事工業組合', dataType: 'String', width: 120, readOnly: true, align: 'right'},
  {binding: 'tsTkCoHbOy', header: '岡山県電気工事工業組合', dataType: 'String', width: 120, readOnly: true, align: 'right'},
  {binding: 'tsTkCoHbHs', header: '広島県電気工事工業組合', dataType: 'String', width: 120, readOnly: true, align: 'right'},
  {binding: 'tsTkCoHbYg', header: '山口県電気工事工業組合', dataType: 'String', width: 120, readOnly: true, align: 'right'},

];

/**
 * 定期調査実施状況画面
 * 画面ID:SCE1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      conditonList: [],
      warningMessages: [],
    };

    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      this.getInitializeData();
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
  }

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    let initItems = {};
    // this.initializeItems(initItems);
    let dataTs = [];
    // let data = {};
    dataTs = [
      {tsTkGubun: '総需要家数'},
      {tsTkGubun: '調査実施総需要家数'},
      {tsTkGubun: '登録調査機関へ調査を委託した需要家数'},
      {tsTkGubun: '調査予定需要家数'},
      {tsTkGubun: '調査実施需要家数'},
      {tsTkGubun: '調査不能需要家数※'},
      {tsTkGubun: '通知需要家数'},
      {tsTkGubun: '再調査実施需要家数'},
      {tsTkGubun: '再調査における通知需要家数'},
    ];

    // データを画面に設定
    this.props.doSetInitValues(initItems);

    this.gridRef.current.setItemsSource(dataTs);

    this.setState({
      // henkoJohomaeList: henkoJohomaeList,
      // conditonList: conditonList,
    });
  };

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    const dataTs =[
      {tsTkGubun: '総需要家数', tsTkCoNw: 'ー', tsTkCoHa: 'ー', tsTkCoHbTt: 'ー', tsTkCoHbSm: 'ー', tsTkCoHbOy: 'ー', tsTkCoHbHs: 'ー', tsTkCoHbYg: 'ー'},
      {tsTkGubun: '調査実施総需要家数', tsTkCoNw: '5,000,000', tsTkCoHa: 'ー', tsTkCoHbTt: 'ー', tsTkCoHbSm: 'ー', tsTkCoHbOy: 'ー', tsTkCoHbHs: 'ー', tsTkCoHbYg: 'ー'},
      {tsTkGubun: '登録調査機関へ調査を委託した需要家数', tsTkCoNw: '5,000,000', tsTkCoHa: 'ー', tsTkCoHbTt: 'ー', tsTkCoHbSm: 'ー', tsTkCoHbOy: 'ー', tsTkCoHbHs: 'ー', tsTkCoHbYg: 'ー'},
      {tsTkGubun: '調査予定需要家数', tsTkCoNw: '200,000', tsTkCoHa: '3,000', tsTkCoHbTt: '3,000', tsTkCoHbSm: '3,000', tsTkCoHbOy: '3,000', tsTkCoHbHs: '3,000', tsTkCoHbYg: '3,000'},
      {tsTkGubun: '調査実施需要家数', tsTkCoNw: '200,000', tsTkCoHa: '3,000', tsTkCoHbTt: '3,000', tsTkCoHbSm: '3,000', tsTkCoHbOy: '3,000', tsTkCoHbHs: '3,000', tsTkCoHbYg: '3,000'},
      {tsTkGubun: '調査不能需要家数※', tsTkCoNw: '0（0）', tsTkCoHa: '766（118）', tsTkCoHbTt: '175（15）', tsTkCoHbSm: '457（2）', tsTkCoHbOy: '0（0）', tsTkCoHbHs: '0（0）', tsTkCoHbYg: '0（0）'},
      {tsTkGubun: '通知需要家数', tsTkCoNw: '200,000', tsTkCoHa: '3,000', tsTkCoHbTt: '3,000', tsTkCoHbSm: '3,000', tsTkCoHbOy: '3,000', tsTkCoHbHs: '3,000', tsTkCoHbYg: '3,000'},
      {tsTkGubun: '再調査実施需要家数', tsTkCoNw: '200,000', tsTkCoHa: '3,000', tsTkCoHbTt: '3,000', tsTkCoHbSm: '3,000', tsTkCoHbOy: '3,000', tsTkCoHbHs: '3,000', tsTkCoHbYg: '3,000'},
      {tsTkGubun: '再調査における通知需要家数', tsTkCoNw: '200,000', tsTkCoHa: '3,000', tsTkCoHbTt: '3,000', tsTkCoHbSm: '3,000', tsTkCoHbOy: '3,000', tsTkCoHbHs: '3,000', tsTkCoHbYg: '3,000'},

    ];

    this.gridRef.current.setItemsSource(dataTs);

    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    // const data =[];
    this.getInitializeData();
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };


  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      align={view.align}
      // cssClass='bf-gray-background'
      isReadOnly={view.readOnly}/>;
  };

  /**
   * 項目フォーマット処理
   *
   * @param {object} s sender
   * @param {string} e event
   */
  formatItemFunction = (s, e) => {
    // 行が存在しない場合は終了
    const rows = s.rows;
    if (rows.length == 0) {
      return;
    }
    if (e.panel.cellType == CellType.Cell) {
      e.cell.style.backgroundColor = '';
      // ReadOnlyのセルか？
      // if (e.cell.ariaReadOnly) {
      //   e.cell.style.backgroundColor = '#e6e6fa';
      // }
    }
    if (e.panel.cellType == CellType.Cell) {
      const col = e.getColumn();
      const data = s.rows[e.row].dataItem;
      if (col && ((col.binding === 'sinnseiStatus' &&
        data.hiKetuFlag === '1') )) {
        // e.cell.style.backgroundColor = '#fff0f5';
        e.cell.style.backgroundColor = '#ff0000';
      }
    }
  };

  doConfirm = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['帳票出力'],
      },
    });
  };

  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'none',
      filterOn: false,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'None',
      AddDeleteOn: false,
      style: {maxHeight: '470px', maxWidth: 'auto', height: 'auto', width: 'auto'},
      isReadOnly: true,
      checkedFunction: this.checkStateUpdate,
      formatItemFunction: this.formatItemFunction,
      // customMergedRange: this.mergedRange,
    };

    let viewElems = [];
    if (TsViews) {
      for (const view of TsViews) {
        const header = view.header;
        if (!header) {
          continue;
        }
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            let secondViewElem;
            let thirdViewGElem;
            // 2層ヘッダー処理
            if (elem.dataType === 'header') {
              let secondViewGroups = [];
              for (const secondElem of elem.elems) {
                if (secondElem.dataType === 'header') {
                  let thirdViewGroups = [];
                  for (const thirdElem of secondElem.elems) {
                    thirdViewGroups.push(this.getViewElem(thirdElem));
                  }
                  thirdViewGElem =
                    <FlexGridColumnGroup header={secondElem.header}>
                      {thirdViewGroups}
                    </FlexGridColumnGroup>;
                  secondViewGroups.push(thirdViewGElem);
                } else {
                  secondViewGroups.push(this.getViewElem(secondElem));
                }
              }
              secondViewElem = <FlexGridColumnGroup header={elem.header}>
                {secondViewGroups}
              </FlexGridColumnGroup>;
              viewGroups.push(secondViewElem);
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="surveyYear" item xs={12} sm={1}>
            <Field
              id="surveyYear"
              name="surveyYear"
              component={renderSelect}
              className="fields"
              label="年度"
              fullWidth
              type="text"
              required={true}
              // validate={[
              //   validateRule.number,
              //   validateRule.maxLength(4),
              // ]}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'2026'}</MenuItem>
              <MenuItem value={2}>{'2025'}</MenuItem>
              <MenuItem value={3}>{'2024'}</MenuItem>
            </Field>
          </Grid>
        </Grid>
        <div style={{marginBottom: '15px'}} />
      </React.Fragment>
    );
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        {/* <Grid key="key1001CreateTen4" item>
          <PositiveButton
            id="btn1001CreateTen4"
            onClick={this.doConfirm}
            variant="contained"
            startIcon={<GetAppIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>完了届兼請求書作成</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001CreateTen4" item>
          <PositiveButton
            id="btn1001CreateTen4"
            onClick={this.doConfirm}
            variant="contained"
            startIcon={<GetAppIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>屋内線定期調査および引込線・計器点検実施報告書作成</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001CreateTen4" item>
          <PositiveButton
            id="btn1001CreateTen4"
            onClick={this.doConfirm}
            variant="contained"
            startIcon={<GetAppIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>屋内線定期調査実施内訳書作成</span>
          </PositiveButton>
        </Grid> */}
      </Grid>
    );
  };

  /**
   * セル結合をカスタム
   * @param {object} wjgGrid wijmo.grid モジュール
   * @param {object} panel 範囲を含むGridPanel
   * @param {number} r セルが含まれる行のインデックス
   * @param {number} c セルが含まれる列のインデックス
   * @param {boolan} clip 結合範囲をグリッドの現在のビュー範囲にクリップするかどうか
   * @return {*} 結合範囲を指定するCellRange
   */
  mergedRange = (wjgGrid, panel, r, c, clip = true) => {
    let rng = new wjgGrid.CellRange(r, c);

    if (panel.cellType == CellType.ColumnHeader) {
      // if (r == 0) {
      //   rng.col = c - (c % 3);
      //   rng.col2 = rng.col + 2;
      //   return rng;
      // }
      // if (r == 0 && ['tsTkGubun1', 'tsTkGubun2'].includes(panel.columns.at(c).binding)) {
      //   rng.col = 0;
      //   rng.col2 = 1;
      //   return rng;
      // }
      if (r == 0 && ['tkTkGubun2', 'tkTkGubun3'].includes(panel.columns.at(c).binding)) {
        rng.col = 0;
        rng.col2 = 1;
        return rng;
      }
    }

    if (panel.cellType == CellType.Cell) {
      if (c < 2) {
        let pcol = c > 0 ? c - 1 : c;
        let pval = panel.getCellData(r, pcol, false);
        let val = panel.getCellData(r, c, false);

        // 縦結合（up）※現行と前行の列が一致
        while (rng.row > 0 &&
          panel.getCellData(rng.row - 1, c, false) == val &&
          panel.getCellData(rng.row - 1, pcol, false) == pval) {
          rng.row--;
        }
        // 縦結合（down）※現行と前行のが一致
        while (rng.row2 < panel.rows.length - 1 &&
          panel.getCellData(rng.row2 + 1, c, false) == val &&
          panel.getCellData(rng.row2 + 1, pcol, false) == pval) {
          rng.row2++;
        }
        // 横結合
        const data = panel.rows[r].dataItem;
        if (data.syokeiMerge) {
          rng.col = 0;
          rng.col2 = 1;
        }
      } else {

      }
    }
    return rng;
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList}/>
          <Grid key="keySCA1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="search" item xs={12}>
                <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '10px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '10px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            {this.renderTable()}
          </Grid>
          <Grid key="keySCA1002HenkomaeTable" item xs={12} sm='4'>
            <Typography variant="h8" gutterBottom align="right">※（）内は調査拒否件数【再掲】</Typography>
          </Grid>
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    initialValues: {
      surveyYear: '1',
      dntNo2: '456',
      dntNo3: '789',
      hikikomiDnt: '123',
      keiyakuNo1: '',
      jigyousyo: '456',
      states: '2',
    },
    // initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);

